<div class="rs-session-timeout-dialog">
  <rs-general-dialog
    i18n-dialogTitle
    dialogTitle="Session Timeout Warning"
    iconPath="assets/icons/exit.png"
    [visible]="visible"
    (visibleChange)="handleVisibleChange($event)"
  >
    <rs-icon headerIcon [icon]="RIPSIM_ICONS.exit"></rs-icon>
    <div i18n>
      You have been inactive for a period of time. To protect sensitive information, your session will automatically logout unless you hit
      the 'Resume' button to continue.
    </div>
    <ng-template pTemplate="footer">
      <p-button i18n-label label="Logout" [outlined]="true" (onClick)="onLogout()" [badge]="logoutCountdown"></p-button>

      <p-button i18n-label label="Resume" (onClick)="onResume()"></p-button>
    </ng-template>
  </rs-general-dialog>
</div>
